import { DataFilterType, DataPropType } from "./DataFilter";
import { DataHeader, MonthNames } from "./DataHeader";
import { g_Dialog } from "@/main";
import DataManager from "./DataManager";
import ChargeStationStatus from "@/js/ChargeStationStatus";
import ChargeStationConnectorStatus from "@/js/ChargeStationConnectorStatus";
import HTTPSender from "@/js/HTTPSender";

var dailySums = {};
var dailyChargesCount = {};
var lastTransactions = {};
var images = {};
var stationsMaxchargeRateKW = {};

var staticData = {
  User: {
    name: "Потребител",
    data: null,
    events: 0,
    is_loading: false,
  },
  ChargeStation: {
    name: "Станции",
    path: "EVUser/Status",
    data: null,
    events: 0,
    is_loading: false,
    filters: [],
    sort: [],
    headers: [
      new DataHeader("Id Станция", "id", DataPropType.String, { isNotForEditing: true }),
      new DataHeader("Име", "name", DataPropType.String, { isNotForEditing: true }),
      new DataHeader("Дата на последен разговор", "lastCPTalk", DataPropType.Date, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Управляващ блок", "fd.sn", DataPropType.String, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Конектори", "onlineConnectors", DataPropType.Object, { isNotForEditing: true, isNullable: true }),
    ],
    toStringFn: function () {
      return this.name;
    },
    loadOnStart: true,
    fixData: () => {
      staticData.ChargeStation.data.forEach((s) => {
        if (!s.Image) {
          if (!s.model) {
            if (s.name.toLowerCase().contains("grasen 22")) {
              if (s.name.toLowerCase().contains("tower")) {
                s.model = "Grasen 22 Tower";
              } else {
                s.model = "Grasen 22";
              }
            } else if (s.name.toLowerCase().contains("grasen 80")) {
              s.model = "Grasen 80";
            } else if (s.name.toLowerCase().contains("abb 22")) {
              s.model = "abb 22";
            } else if (s.name.toLowerCase().contains("abb 365")) {
              s.model = "abb 365";
            } else if (s.name.toLowerCase().contains("abb 184")) {
              s.model = "abb 184";
            } else if (s.name.toLowerCase().contains("scu")) {
              s.model = "SCU";
            } else if (s.name.toLowerCase().contains("alpi")) {
              s.model = "ALPITRONIC150";
            } else {
              s.model = "DEFAULT";
            }
          }
          var model = (s.model ? s.model : s.name).trim().replaceAll(" ", "").toUpperCase();

          // s.ImageUrl = "@/assets/image/" + model + ".png";
          // if (!images[model]) {
          //   try {
          //     images[model] = require("@/assets/image/" + model + ".png");
          //   } catch {
          //     images[model] = require("@/assets/image/DEFAULT.png");
          //   }
          // }

          s.ImageUrl = `${process.env.BASE_URL}images/${model}.png`;
          
          if (!images[model]) {
            images[model] = s.ImageUrl;
          }

          s.Image = images[model];
          try {
            s.Power = Number(s.model.split(" ")[1]);
            if (s.Power > 22) {
              s.Power = Math.trunc(s.Power / 10) * 10;
              s.PowerType = "DC";
            } else {
              s.PowerType = "AC";
            }
          } catch {
            /** */
          }

          // if (model.toLowerCase().contains("abb 365")) {
          //   s.Power = 360;
          // } else if (model.toLowerCase().contains("abb 184")) {
          //   s.Power = 180;
          // } else if (model.toLowerCase().contains("abb 54")) {
          //   s.Power = 50;
          // } else if (model.toLowerCase().contains("abb 22")) {
          //   s.Power = 22;
          // } else if (model.toLowerCase().contains("alpitronic 150")) {
          //   s.Power = 150;
          // } else if (model.toLowerCase().contains("alpitronic 50")) {
          //   s.Power = 50;
          // } else if (model.toLowerCase().contains("grasen 80")) {
          //   s.Power = 80;
          // } else if (model.toLowerCase().contains("grasen 60")) {
          //   s.Power = 60;
          // } else if (model.toLowerCase().contains("grasen 22")) {
          //   s.Power = 22;
          // } else if (model.toLowerCase().contains("alpi")) {
          //   s.Power = 150;
          // } else if (model.toLowerCase().contains("смук") || model.toLowerCase().contains("gras")) {
          //   s.Power = 22;
          // } else if (model.toLowerCase().contains("scu")) {
          //   s.Power = 120;
          // }
        }
        if (!s.fd) {
          try {
            s.fd = s.onlineConnectors["1"].fd;
          } catch {
            s.fd = { sn: "" };
          }
        }
        if (!(s.lastCPTalk instanceof Date)) {
          s.lastCPTalk = new Date(s.lastCPTalk);
        }
        if (s.location && JSON.tryParse(s.location)) {
          s.location = JSON.parse(s.location);
        } else {
          s.location = { lat: "", lng: "" };
        }
        if (s.settings1 && JSON.tryParse(s.settings1)) {
          s.settings1 = JSON.parse(s.settings1);
        } else {
          s.settings1 = {
            Address: "",
          };
        }
        Object.defineProperty(s, "Address", {
          get() {
            return s.settings1.Address ?? "";
          },
          set(val) {
            if (val != s.settings1.Address) {
              s.location = undefined;
            }
            s.settings1.Address = val;
          },
          configurable: true,
          enumerable: true,
        });

        var conO = Object.keys(s.onlineConnectors);
        if (conO.length == 0) {
          s.Status = ChargeStationStatus.NotConnected;
        } else if (s.lastCPTalk.addMinutes(10).getTime() > new Date().getTime()) {
          s.Status = ChargeStationStatus.Online;
          s.IsOnline = true;
        } else {
          s.Status = ChargeStationStatus.Offline;
        }

        s.CurrentlyActive = 0;
        s.ChargeRateKW = 0;

        if (!s.SumToday)
          Object.defineProperty(s, "SumToday", {
            get() {
              return dailySums[s.id] ?? 0;
            },
            configurable: true,
            enumerable: true,
          });

        if (!s.ChargesToday)
          Object.defineProperty(s, "ChargesToday", {
            get() {
              return dailyChargesCount[s.id] ?? 0;
            },
            configurable: true,
            enumerable: true,
          });

        conO.forEach((key) => {
          var c = s.onlineConnectors[key];
          c.StateOfCharge = undefined;

          if (!c.LastTransaction)
            Object.defineProperty(c, "LastTransaction", {
              get() {
                return lastTransactions[s.id + "_" + key];
              },
              // set(val) {
              //   s.LastTransaction = val;
              // },
              configurable: true,
              enumerable: true,
            });

          s.Price = c.price_per_kwh;

          if (s.Status == ChargeStationStatus.NotConnected) {
            c.IconColor = "lightgray";
            c.Icon = "mdi-ev-plug-ccs2";
          } else if (s.Status == ChargeStationStatus.Offline) {
            c.IconColor = "red";
            c.Icon = "mdi-ev-plug-ccs2";
          } else {
            if (c.propsIsAC) {
              c.Icon = "mdi-ev-plug-type2";
              c.Type = "AC";
            } else if (c.propsIsCHADEMO) {
              c.Icon = "mdi-ev-plug-chademo";
              c.Type = "Chademo";
            } else {
              c.Icon = "mdi-ev-plug-ccs2";
              c.Type = "CCS2";
            }
            switch (c.statusNotifReqStr) {
              case ChargeStationConnectorStatus.Unavailable:
              case ChargeStationConnectorStatus.Offline:
              case ChargeStationConnectorStatus.Faulted:
                c.IconColor = "red";
                break;
              case ChargeStationConnectorStatus.Available:
                // if (c.TransactionStopTime) c.TransactionStopTime = undefined;
                // lastTransactions[s.id + "_" + key] = undefined;
                stationsMaxchargeRateKW[s.id + "_" + key] = undefined;
                c.IconColor = "";
                break;

              case ChargeStationConnectorStatus.Preparing:
              case ChargeStationConnectorStatus.Finishing:
                c.IconColor = "yellow";
                s.CurrentlyActive++;
                break;

              case ChargeStationConnectorStatus.Charging:
                s.CurrentlyActive++;
                c.IconColor = "green";
                c.StateOfCharge = (c.chargeRateKW ? "🗲" + c.chargeRateKW.toFixed(3) + "    " : "") + (c.soC ? c.soC + "%" : " ");

                if (stationsMaxchargeRateKW[s.id + "_" + key] == undefined || c.chargeRateKW > stationsMaxchargeRateKW[s.id + "_" + key]) {
                  stationsMaxchargeRateKW[s.id + "_" + key] = c.chargeRateKW;
                }
                c._MaxchargeRateKW = stationsMaxchargeRateKW[s.id + "_" + key];
                if (c.chargeRateKW) {
                  s.ChargeRateKW += c.chargeRateKW;
                }
                break;
              default:
                c.IconColor = undefined;
                break;
            }
          }
        });
      });
      staticData.ChargeStation.data.sort((a, b) => {
        // return a.name.localeCompare(b.name);
        return a.Status - b.Status || a.name.localeCompare(b.name); // || (a.fd && b.fd) ? a.fd.sn.localeCompare(b.fd.sn) : 0;
      });
    },
  },
  DailyTransactions: {
    name: "Дневен оборот",
    path: "EVUser/GetTransactions",
    queryParams: () => {
      var dates = staticData.DailyTransactions.dates;
      var o = {};
      o.from = dates[0].toStringWithFormat("dd-MM-yyyy HH:mm");
      o.to = dates[dates.length - 1].toStringWithFormat("dd-MM-yyyy HH:mm");
      return o;
    },
    dates: [new Date().getDateWithoutTime(), new Date()],
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("ID", "transactionId", DataPropType.String, { isNotForEditing: true, isHidden: true }),
      new DataHeader("Сума", "completeAmount", DataPropType.Money, { isNotForEditing: true, isHidden: true, isNullable: true }),
    ],
    fixData: () => {
      staticData.ChargeStation.data.forEach((st) => {
        dailySums[st.id] = 0;
        dailyChargesCount[st.id] = 0;
      });
      staticData.DailyTransactions.data.sort((a, b) => {
        return a.transactionId - b.transactionId;
      });
      staticData.DailyTransactions.data.forEach((t) => {
        var s = staticData.ChargeStation.data.find((s) => s.id == t.chargePointId);
        if (s) {
          if (t.completeFinished) {
            if (t.completeAmount && !t.notPayedForcedStop && !t.companyRfidUsed) {
              dailySums[s.id] += t.completeAmount.roundTo(2);
            }
            dailyChargesCount[s.id] += 1;
          }
          if (s.onlineConnectors[t.connectorId]) {
            lastTransactions[s.id + "_" + t.connectorId] = t;
            // console.log(lastTransactions);
          }
        }
      });
    },
  },
  Transactions: {
    name: "Транзакции",
    path: "EVUser/GetTransactions",
    queryParams: () => {
      var o = {};
      var dates = staticData.Transactions.dates;
      if (dates[0]) {
        o.from = dates[0].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      if (dates[dates.length - 1]) {
        o.to = dates[dates.length - 1].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      return o;
    },
    dates: new Date().getFirstDayOfMonth().createArray(new Date().getDate235959()),
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("N", "my_custom_id", DataPropType.Number, { isNotForEditing: true, isNotForClicking: true, isHidden: true }),
      new DataHeader("ID", "transactionId", DataPropType.String, { isNotForEditing: true }),
      new DataHeader("Станция", "ChargeStation", DataPropType.Object, { isNotForEditing: true, canBeGrouped: true, width: "200px" }),
      new DataHeader("Id Станция", "chargePointId", DataPropType.String, { isNotForEditing: true, isHidden: true }),
      new DataHeader("Id Конектор", "connectorId", DataPropType.String, { isNotForEditing: true, isHidden: true, filtertype: DataFilterType.In }),
      new DataHeader("Тип конектор", "Connector.Type", DataPropType.String, { isNotForEditing: true, filtertype: DataFilterType.In }),
      new DataHeader("Стартиране", "startTime", DataPropType.Date, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Приключване", "stopTime", DataPropType.Date, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Минути", "_DurationInMinutes", DataPropType.Number, { isNotForEditing: true, isNullable: true, cell_align: "end", summable: true }),
      new DataHeader("Тип", "type", DataPropType.String, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Сума", "completeAmount", DataPropType.Money, { isNotForEditing: true, isNullable: true, cell_align: "end", summable: true }),
      new DataHeader("Количество (KWh)", "kwh", DataPropType.QTY, { isNotForEditing: true, isNullable: true, cell_align: "end", summable: true }),
      new DataHeader("Фирма", "Tag.cevuser.invCompanyName", DataPropType.String, { isNotForEditing: true, isNullable: true }),
      // new DataHeader("Коментар", "Tag.tagName", DataPropType.String, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Коментар", "chargeTagCevUser.tagName", DataPropType.String, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Автомобил", "vehicleId", DataPropType.String, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Цена\nза 1 KWh", "price1Kwh", DataPropType.Money, { isNotForEditing: true, isHidden: true, cell_align: "end" }),
      new DataHeader("Сума\nпреавторизация", "preAuthAmount", DataPropType.Money, {
        isNotForEditing: true,
        summable: true,
        isHidden: true,
        isNullable: true,
        cell_align: "end",
      }),
      new DataHeader("Код за\nпреавторизация", "preAuthCode", DataPropType.String, { isNotForEditing: true, isHidden: true, isNullable: true }),
      new DataHeader("Завършена", "completeFinished", DataPropType.BOOL, { isNotForEditing: true, isHidden: true, cell_align: "center" }),
    ],
    toStringFn: function () {
      return this.name;
    },
    fixData: async () => {
      await DataManager.loadData(staticData.Tags);
      var tags = DataManager.getData(staticData.Tags, true);
      staticData.Transactions.data.forEach((t) => {
        t.ChargeStation = staticData.ChargeStation.data.find((s) => s.id == t.chargePointId);
        if (t.startTime) {
          t.YY = t.startTime.getFullYear();
          t.MM = t.startTime.getMonth();
          t.Month = MonthNames[t.MM];
          t.DWT = t.startTime.getDateWithoutTime();
          t.DWTT = t.DWT.getTime();
          if (t.stopTime) {
            t._DurationInMinutes = Math.floor((t.stopTime - t.startTime) / 1000 / 60);
          }
        }
        if (t.completeAmount) {
          if (t.notPayedForcedStop || t.companyRfidUsed) {
            t.completeAmount = 0;
          } else {
            t.completeAmount = t.completeAmount.roundTo(2);
          }
        }
        t.Tag = tags.find((tag) => tag.tagId == t.startTagId);
        if (t.ChargeStation) {
          //TODO price not here
          if (!t.ChargeStation.Price) {
            t.ChargeStation.Price = t.price1Kwh;
          }
          if (t.ChargeStation.onlineConnectors[t.connectorId]) {
            t.Connector = t.ChargeStation.onlineConnectors[t.connectorId];
          }
          // if (t.ChargeStation.onlineConnectors[t.connectorId] && !t.ChargeStation.onlineConnectors[t.connectorId].LastTransaction) {
          //   t.ChargeStation.onlineConnectors[t.connectorId].LastTransaction = t;
          // }
        }

        if (t.type === null) {
          // Тошо връща RFID / VID_AUTOCHARGE или нулл
          t.type = "POS";
        }
      });
    },
  },
  DailySalesByChargePoint: {
    name: "Оборот по дни за станции",
    path: "EVUser/GetTransactions",
    queryParams: () => {
      var o = {};
      var dates = staticData.DailySalesByChargePoint.dates;
      if (dates[0]) {
        o.from = dates[0].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      if (dates[dates.length - 1]) {
        o.to = dates[dates.length - 1].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      return o;
    },
    dates: new Date().getFirstDayOfMonth().createArray(new Date().getDate235959()),
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("Дата", "DWT", DataPropType.DateShort, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Ден от седмицата", "WeekDay", DataPropType.WeekDays, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Станция", "ChargeStation", DataPropType.Object, { isNotForEditing: true }),
      new DataHeader("Id Станция", "chargePointId", DataPropType.String, { isNotForEditing: true, isHidden: true }),
      new DataHeader("Сума", "completeAmount", DataPropType.Money, { isNotForEditing: true, isNullable: true, cell_align: "end", summable: true }),
    ],
    toStringFn: function () {
      return this.name;
    },
    fixData: () => {
      staticData.DailySalesByChargePoint.data.forEach((t) => {
        var cp = staticData.ChargeStation.data.find((s) => s.id == t.chargePointId);
        if (cp) {
          t.ChargeStation = cp; // Object.assign({}, cp);
          //delete t.ChargeStation.onlineConnectors;
        }
        if (t.startTime) {
          t.DWT = t.startTime.getDateWithoutTime();
          t.WeekDay = DataManager.WeekDays[t.DWT.getDay()];
        }
        if (t.completeAmount) {
          if (t.notPayedForcedStop || t.companyRfidUsed) {
            t.completeAmount = 0;
          } else {
            t.completeAmount = t.completeAmount.roundTo(2);
          }
        }
      });
      staticData.DailySalesByChargePoint.data = staticData.DailySalesByChargePoint.data.groupByAndSum("completeAmount", "chargePoint", "chargePointId", "DWT");
      staticData.DailySalesByChargePoint.data = staticData.DailySalesByChargePoint.data.reverse();
    },
  },
  DailySales: {
    name: "Оборот по дни",
    path: "EVUser/GetTransactions",
    queryParams: () => {
      var o = {};
      var dates = staticData.DailySales.dates;
      if (dates[0]) {
        o.from = dates[0].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      if (dates[dates.length - 1]) {
        o.to = dates[dates.length - 1].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      return o;
    },
    dates: new Date().getFirstDayOfMonth().createArray(new Date().getDate235959()),
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("Дата", "DWT", DataPropType.DateShort, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Ден от седмицата", "WeekDay", DataPropType.WeekDays, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Сума", "completeAmount", DataPropType.Money, { isNotForEditing: true, isNullable: true, cell_align: "end", summable: true }),
    ],
    toStringFn: function () {
      return this.name;
    },
    fixData: () => {
      if (staticData.DailySales.data && staticData.DailySales.data.length > 0) {
        staticData.DailySales.data.forEach((t) => {
          if (t.startTime) {
            t.DWT = t.startTime.getDateWithoutTime();
            t.WeekDay = DataManager.WeekDays[t.DWT.getDay()];
          }
          if (t.completeAmount) {
            if (t.notPayedForcedStop || t.companyRfidUsed) {
              t.completeAmount = 0;
            } else {
              t.completeAmount = t.completeAmount.roundTo(2);
            }
          }
        });
        staticData.DailySales.data = staticData.DailySales.data.groupByAndSum("completeAmount", "DWT");
        staticData.DailySales.data = staticData.DailySales.data.reverse();
      }
    },
  },
  MonthlySales: {
    name: "Оборот по месеци",
    path: "EVUser/GetTransactions",
    queryParams: () => {
      var o = {};
      var dates = staticData.MonthlySales.dates;
      if (dates[0]) {
        o.from = dates[0].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      if (dates[dates.length - 1]) {
        o.to = dates[dates.length - 1].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      return o;
    },
    dates: new Date().getFirstDayOfMonth().createArray(new Date().getDate235959()),
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("Месец", "Month", DataPropType.Month, { isNotForEditing: true, isNullable: true, maxwidth: 250 }),
      new DataHeader("Година", "YY", DataPropType.Number, { isNotForEditing: true, isNullable: true, maxwidth: 250, filtertype: DataFilterType.In }),
      new DataHeader("Сума", "completeAmount", DataPropType.Money, {
        isNotForEditing: true,
        isNullable: true,
        cell_align: "end",
        summable: true,
        maxwidth: 250,
      }),
    ],
    toStringFn: function () {
      return this.name;
    },
    fixData: () => {
      if (staticData.MonthlySales.data && staticData.MonthlySales.data.length > 0) {
        staticData.MonthlySales.data.forEach((t) => {
          if (t.startTime) {
            t.DWT = t.startTime.getDateWithoutTime();
            t.MM = t.startTime.getMonth();
            t.Month = MonthNames[t.MM];
            t.YY = t.startTime.getFullYear();
          }
          if (t.completeAmount) {
            if (t.notPayedForcedStop || t.companyRfidUsed) {
              t.completeAmount = 0;
            } else {
              t.completeAmount = t.completeAmount.roundTo(2);
            }
          }
        });
        staticData.MonthlySales.data = staticData.MonthlySales.data.groupByAndSum("completeAmount", "Month", "YY");
        staticData.MonthlySales.data = staticData.MonthlySales.data.reverse();
      }
    },
  },
  ForInvoicing: {
    name: "За отчитане",
    path: "EVUser/GetMonthlyTotals",
    queryParams: () => {
      var dt = new Date().addMonths(-1);
      return { month: (dt.getMonth() + 1).toString().padStart(2, "0") + "-" + dt.getFullYear() };
    },
    dates: null,
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("Месец", "Month", DataPropType.Month, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Година", "Year", DataPropType.Number, { isNotForEditing: true, isNullable: true }),
      new DataHeader("Станция", "ChargeStation", DataPropType.String, { isNotForEditing: true, isNullable: true }),
      new DataHeader("За фактуриране", "ForInvoicing", DataPropType.Money, { isNotForEditing: true, isNullable: true, summable: true }),
      new DataHeader("Общо дължимо", "totalForPay", DataPropType.Money, { isNotForEditing: true, isNullable: true, summable: true }),
      new DataHeader("Оборот от транзакции", "totalTransactionsAmount", DataPropType.Money, { isNotForEditing: true, isNullable: true, summable: true }),
      new DataHeader("От процент от оборота", "turnoverPercentForPay", DataPropType.Money, { isNotForEditing: true, isNullable: true, summable: true }),
      new DataHeader("Месечен абонамент", "subscriptionForPay", DataPropType.Money, { isNotForEditing: true, isNullable: true, summable: true }),
    ],
    toStringFn: function () {
      return this.name;
    },
    fixData: () => {
      var dt = new Date().addMonths(-1);
      if (staticData.ForInvoicing.data) {
        staticData.ForInvoicing.data.forEach((d) => {
          d.Month = MonthNames[dt.getMonth()];
          d.Year = dt.getFullYear();
          d.ForInvoicing = d.totalTransactionsAmount - d.totalForPay;
          d.ChargeStation = staticData.ChargeStation.data.find((c) => c.id == d.chargePointId);
        });
      }
    },
  },
  ChartDaily: {
    name: "Графика дневни продажби",
    path: "EVUser/GetTransactions",
    queryParams: () => {
      var o = {};
      var dates = staticData.ChartDaily.dates;
      if (dates[0]) {
        o.from = dates[0].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      if (dates[dates.length - 1]) {
        o.to = dates[dates.length - 1].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      return o;
    },
    dates: new Date().getFirstDayOfMonth().createArray(new Date().getDate235959()),
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("Станция", "ChargeStation", DataPropType.Object, { isNotForEditing: true }),
      new DataHeader("Дата", "startTime", DataPropType.Date, { isNotForEditing: true }),
    ],
    toStringFn: function () {
      return this.name;
    },
    chart: {
      formatterX: (val) => (val ? new Date(val).toTremolFpStringShort() : "0"),
      formatterTooltip: (val) => (val ? val : "0"),
      formatterY: (val) => (val != null && val != undefined ? val.toFixed(2) + " €" : undefined),
      xAxisType: "datetime",
      series: [],
      seriesSUM: [],
      categories: [],
      categoriesSUM: [],
    },
    fixData: () => {
      staticData.ChartDaily.data.forEach((t) => {
        //TODO clean not used propz
        t.ChargeStation = staticData.ChargeStation.data.find((s) => s.id == t.chargePointId);
        t.YY = t.startTime.getFullYear();
        t.MM = t.startTime.getMonth();
        t.Month = MonthNames[t.MM];
        t.DWT = t.startTime.getDateWithoutTime();
        t.DWTT = t.DWT.getTime();
      });
    },
    generateChartData: () => {
      staticData.ChartDaily.chart.series = [];
      staticData.ChartDaily.chart.seriesSUM = [];
      staticData.ChartDaily.chart.categories = [];
      staticData.ChartDaily.chart.categoriesSUM = [];
      staticData.ChartDaily.chart.series.push({ name: "Общо", data: [] });

      var data = DataManager.getData(staticData.ChartDaily);
      if (!data) return [];

      var s_dates = [
        ...new Set(
          data.map((e) => {
            return e.DWTT;
          })
        ),
      ];
      var s_max_date = new Date(Math.max(...s_dates)).getDateWithoutTime();
      var s_min_date = new Date(Math.min(...s_dates)).getDateWithoutTime();
      // var s_max_date = dates[0];
      // var s_min_date = dates[dates.length - 1];
      var s_data = data.filter((d) => d.startTime > s_min_date).sort((a, b) => b.startTime - a.startTime);
      var s_start_date = s_min_date;

      while (s_start_date <= s_max_date) {
        var s_start_date_time = s_start_date.getTime();
        var dailySum = s_data
          .naiveForFilter((ee) => ee.DWTT === s_start_date_time)
          .map((r) => r.completeAmount)
          .sum()
          .roundTo(2);
        staticData.ChartDaily.chart.series[0].data.push(dailySum);
        staticData.ChartDaily.chart.seriesSUM.push(dailySum);
        staticData.ChartDaily.chart.categories.push(s_start_date.addHours(12).toUTCString());
        staticData.ChartDaily.chart.categoriesSUM.push(s_start_date.toTremolFpStringShort());
        s_start_date = s_start_date.addDays(1);
      }
      staticData.ChartDaily.chart.categoriesSUM = staticData.ChartDaily.chart.categoriesSUM.reverse();
    },
  },
  ChartByHours: {
    name: "Заряди по часове",
    path: "EVUser/GetTransactions",
    queryParams: () => {
      var o = {};
      var dates = staticData.ChartByHours.dates;
      if (dates[0]) {
        o.from = dates[0].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      if (dates[dates.length - 1]) {
        o.to = dates[dates.length - 1].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      return o;
    },
    dates: new Date().getDateWithoutTime().createArray(new Date().getDate235959()),
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("Станция", "ChargeStation", DataPropType.Object, { isNotForEditing: true }),
      new DataHeader("Дата", "startTime", DataPropType.Date, { isNotForEditing: true }),
    ],
    toStringFn: function () {
      return this.name;
    },
    chart: {
      formatterX: (val) => (val != undefined && val != null ? val.toFixed(0) + " ч." : "0"),
      formatterTooltip: (val) => (val != undefined && val != null ? val.toFixed(0) + "-" + (val + 1).toFixed(0) + " ч." : "0"),
      formatterY: (val) => (val != undefined && val != null ? val.toFixed(0) : "0"), // formatterY: (val) => (val ? val.toFixed(2) + " €" : undefined),
      xAxisType: "category",
      series: [],
      seriesSUM: [],
      categories: [],
      categoriesSUM: [],
    },
    fixData: () => {
      staticData.ChartByHours.data.forEach((t) => {
        //TODO clean not used propz
        t.ChargeStation = staticData.ChargeStation.data.find((s) => s.id == t.chargePointId);
        t.HH = t.startTime.getHours();
        t.DWT = t.startTime.getDateWithoutTime();
        t.DWTT = t.DWT.getTime();
      });
    },
    generateChartData: () => {
      staticData.ChartByHours.chart.series = [];
      staticData.ChartByHours.chart.seriesSUM = [];
      staticData.ChartByHours.chart.categories = [];
      staticData.ChartByHours.chart.categoriesSUM = [];

      var data = DataManager.getData(staticData.ChartByHours);
      if (!data) return [];

      var s_hours = [...new Set(data.map((e) => e.HH))];
      var s_min_hour = Math.min(...s_hours);
      var s_max_hour = Math.max(...s_hours);
      var s_dates = [
        ...new Set(
          data.map((e) => {
            return e.DWTT;
          })
        ),
      ];
      var s_max_date = new Date(Math.max(...s_dates)).getDateWithoutTime();
      var s_min_date = new Date(Math.min(...s_dates)).getDateWithoutTime();
      // var s_max_date = dates[0];
      // var s_min_date = dates[dates.length - 1];
      var daysDiff = s_min_date.daysDiff(s_max_date);
      if (daysDiff == 0) {
        staticData.ChartByHours.chart.series.push({ name: "Общо", data: [] });
      } else {
        staticData.ChartByHours.chart.series.push({ name: "Средно за " + (daysDiff + 1) + " дни", data: [] });
      }

      for (var hh = s_min_hour; hh <= s_max_hour; hh++) {
        staticData.ChartByHours.chart.series[0].data.push(0);
        staticData.ChartByHours.chart.seriesSUM.push(0);
        staticData.ChartByHours.chart.categories.push(hh);
        staticData.ChartByHours.chart.categoriesSUM.push(hh.toFixed(0) + "-" + (hh + 1).toFixed(0) + " ч.");
      }
      data.forEach((s) => {
        staticData.ChartByHours.chart.series[0].data[s.HH - s_min_hour] += 1;
        staticData.ChartByHours.chart.seriesSUM[s.HH - s_min_hour] += 1;
      });
      for (var i = 0; i < staticData.ChartByHours.chart.series[0].data.length; i++) {
        staticData.ChartByHours.chart.seriesSUM[i] = staticData.ChartByHours.chart.seriesSUM[i] / (daysDiff + 1);
        staticData.ChartByHours.chart.series[0].data[i] = staticData.ChartByHours.chart.series[0].data[i] / (daysDiff + 1);
      }
      staticData.ChartByHours.chart.categoriesSUM = staticData.ChartByHours.chart.categoriesSUM.reverse();
    },
  },

  ChartMonthly: {
    name: "Графика продажби този месец",
    path: "EVUser/GetTransactions",

    queryParams: () => {
      var o = {};
      var dates = staticData.ChartMonthly.dates;
      if (dates[0]) {
        o.from = dates[0].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      if (dates[dates.length - 1]) {
        o.to = dates[dates.length - 1].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      return o;
    },
    dates: new Date().getFirstDayOfMonth().createArray(new Date().getFirstDayOfMonth().addMonths(1).addSeconds(-1)),
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("Дата", "startTime", DataPropType.Date, { isNotForEditing: true }),
      new DataHeader("Сума", "completeAmount", DataPropType.Money, { isNotForEditing: true, isHidden: true, isNullable: true }),
    ],
    toStringFn: function () {
      return this.name;
    },
    chart: {
      formatterX: (val) => (!val ? "0%" : val.toFixed(2) + "%"),
      formatterY: (val) => (val != null && val != undefined ? val.toFixed(2) + " €" : undefined),
      formatterTooltip: (val) => val.toString().split("\n")[0],
      xAxisType: "category",
      series: [],
      seriesSUM: [],
      categories: [],
      categoriesSUM: [],
      title: "Месечен оборот",
    },
    fixData: () => {},
    generateChartData: () => {
      staticData.ChartMonthly.chart.seriesSUM = [];
      staticData.ChartMonthly.chart.categoriesSUM = [];

      var data = DataManager.getData(staticData.ChartMonthly);
      if (!data) return [];

      var bankSum = data
        .filter((d) => d.preAuthCode != null && !!d.completeAmount)
        .map((s) => s.completeAmount)
        .sum()
        .roundTo(2);
      var rfidSum = data
        .filter((d) => d.preAuthCode == null && !!d.completeAmount)
        .map((s) => s.completeAmount)
        .sum()
        .roundTo(2);
      staticData.ChartMonthly.chart.seriesSUM.push(bankSum, rfidSum);
      staticData.ChartMonthly.chart.categoriesSUM.push(...["POS терминал:\n" + bankSum + " €", "RFID, Autocharge:\n" + rfidSum + " €"]);
      staticData.ChartMonthly.chart.title = MonthNames[staticData.ChartMonthly.dates[0].getMonth()] + ": " + (bankSum + rfidSum).toFixed(2) + " €";
    },
  },

  ChartByStations: {
    name: "Графика продажби по станции",
    path: "EVUser/GetTransactions",

    queryParams: () => {
      var o = {};
      var dates = staticData.ChartByStations.dates;
      if (dates[0]) {
        o.from = dates[0].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      if (dates[dates.length - 1]) {
        o.to = dates[dates.length - 1].toStringWithFormat("dd-MM-yyyy HH:mm");
      }
      return o;
    },
    dates: new Date().getFirstDayOfMonth().createArray(new Date().getFirstDayOfMonth().addMonths(1).addSeconds(-1)),
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("Станция", "ChargeStation", DataPropType.Object, { isNotForEditing: true }),
      new DataHeader("Сума", "completeAmount", DataPropType.Money, { isNotForEditing: true, isNullable: true }),
    ],
    toStringFn: function () {
      return this.name;
    },
    chart: {
      formatterX: (val) => val,
      formatterY: (val) => (val != null && val != undefined ? val.toFixed(2) + " €" : undefined),
      formatterTooltip: (val) => val.toString().split("\n")[0],
      xAxisType: "category",
      series: [],
      seriesSUM: [],
      categories: [],
      categoriesSUM: [],
      title: "Продажби по станции",
    },
    fixData: () => {
      staticData.ChartByStations.data = staticData.ChartByStations.data.groupByAndSum("completeAmount", "chargePointId");
      staticData.ChartByStations.data = staticData.ChartByStations.data.reverse();
      staticData.ChartByStations.data.forEach((t) => {
        t.ChargeStation = staticData.ChargeStation.data.find((s) => s.id == t.chargePointId);
      });
    },
    generateChartData: () => {
      staticData.ChartByStations.chart.series = [];
      staticData.ChartByStations.chart.seriesSUM = [];
      staticData.ChartByStations.chart.categories = [];
      staticData.ChartByStations.chart.categoriesSUM = [];

      var data = DataManager.getData(staticData.ChartByStations);
      if (!data) return [];
      data = data.sortByDesc("completeAmount");
      staticData.ChartByStations.chart.series.push({ name: "Сума", data: [] });
      data.forEach((d) => {
        staticData.ChartByStations.chart.series[0].data.push(d.completeAmount);
        staticData.ChartByStations.chart.seriesSUM.push(d.completeAmount);
        staticData.ChartByStations.chart.categories.push(d.ChargeStation.toString());
        staticData.ChartByStations.chart.categoriesSUM.push(d.ChargeStation.toString());
      });
    },
  },

  EVUsers: {
    name: "Клиент",
    path: "EVUser/GetEvUsers",
    queryParams: null,
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("N", "my_custom_id", DataPropType.Number, { isNotForEditing: true, isNotForClicking: true }),
      new DataHeader("id", "id", DataPropType.Number, { isNotInSelector: true, isNotForEditing: true, isHidden: true }),
      new DataHeader("Фирма", "invCompanyName", DataPropType.String, {}),
      new DataHeader("Парола", "password", DataPropType.String, {}),
      new DataHeader("E-mail", "email", DataPropType.String, {}),
      new DataHeader("ЕИК", "invEik", DataPropType.String, {}),
      new DataHeader("ЗДДС Номер", "invZddsnom", DataPropType.String, { isNullable: true }),
      new DataHeader("МОЛ", "invMol", DataPropType.String, { isNullable: true }),
      new DataHeader("Адрес по регистрация", "invRegAddress", DataPropType.String, { isNullable: true }),
    ],
    fixData: () => {},
    add: (itm) =>
      new Promise((resolve) => {
        var item = {};
        if (itm) {
          item = itm;
        } else {
          staticData.EVUsers.headers.forEach((h) => {
            item[h.value] = null;
          });
        }
        g_Dialog.show(
          g_Dialog.dialog_types.editor,
          item,
          {
            title: "Добавяне на клиент",
            headers: staticData.EVUsers.headers,
          },
          (added_item) => {
            if (added_item) {
              delete added_item.Id;
              HTTPSender.SendPOSTreq(JSON.stringify(added_item), "EVUser/AddOrUpdateCEVUser")
                .done((resp) => {
                  if (resp.success) {
                    resolve(true);
                    g_Dialog.showInfo("Успешно добавяне на клиент.");
                  } else {
                    resolve(false);
                    staticData.EVUsers.add(added_item);
                    g_Dialog.showError("Грешка при добавяне на клиент!\n" + resp.err ? resp.err.message : "");
                  }
                })
                .fail((xhr, textStatus, errorThrown) => {
                  console.log(errorThrown);
                  resolve(null);
                });
            }
          }
        );
      }),
    edit: (item) =>
      new Promise((resolve) => {
        g_Dialog.show(
          g_Dialog.dialog_types.editor,
          item,
          {
            title: "Редакция на клиент",
            headers: staticData.EVUsers.headers,
          },
          (changed_item) => {
            if (changed_item) {
              HTTPSender.SendPOSTreq(JSON.stringify(changed_item), "EVUser/AddOrUpdateCEVUser")
                .done((resp) => {
                  if (resp.success) {
                    resolve(true);
                    g_Dialog.showInfo("Успешна редакция на клиент.");
                  } else {
                    resolve(false);
                    staticData.EVUsers.add(changed_item);
                    g_Dialog.showError("Грешка при редакция на клиент!\n" + resp.err ? resp.err.message : "");
                  }
                })
                .fail((xhr, textStatus, errorThrown) => {
                  console.log(errorThrown);
                  resolve(null);
                });
            }
          }
        );
      }),
  },
  Tags: {
    name: "Tags",
    path: "EVUser/GetCTags",
    queryParams: null,
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("N", "my_custom_id", DataPropType.Number, { isNotForEditing: true, isNotForClicking: true, isHidden: true }),
      new DataHeader("Тип", "type", DataPropType.String, {}),
      new DataHeader("Идентификатор", "tagId", DataPropType.String, { isNotForEditing: true }),
      new DataHeader("Клиент", "cevuser.invCompanyName", DataPropType.String, { isNotForEditing: true, isHidden: true }),
      new DataHeader("Име", "tagName", DataPropType.String, {}),
      new DataHeader("AutoCharge", "vidAutoCharge", DataPropType.BOOL, {}),
      new DataHeader("Цена", "customPrice", DataPropType.Money, { isNullable: true }),
      new DataHeader("Блокиран", "blocked", DataPropType.BOOL, {}),
    ],
    fixData: () => {
      staticData.Tags.data.sort((a, b) => a.type.localeCompare(b.type));
    },
  },
  Cars: {
    name: "Cars",
    path: "EVUser/GetCTags",
    queryParams: null,
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("N", "my_custom_id", DataPropType.Number, { isNotForEditing: true, isNotForClicking: true, isHidden: true }),
      new DataHeader("Идентификатор", "tagId", DataPropType.String, { isNotForEditing: true }),
      new DataHeader("Клиент", "cevuser.invCompanyName", DataPropType.String, { isNotForEditing: true, isHidden: true }),
      new DataHeader("Тип", "type", DataPropType.String, { isHidden: true }),
      new DataHeader("Име", "tagName", DataPropType.String, {}),
      new DataHeader("AutoCharge", "vidAutoCharge", DataPropType.BOOL, { isNullable: true }),
      new DataHeader("Цена", "customPrice", DataPropType.Money, { isNullable: true }),
      new DataHeader("Блокиран", "blocked", DataPropType.BOOL, {}),
    ],
    fixData: () => {
      for (var i = staticData.Cars.data.length - 1; i >= 0; i--) {
        if (staticData.Cars.data[i].type.toUpperCase().contains("CARD")) {
          staticData.Cars.data.splice(i, 1);
        }
      }
    },
  },
  Cards: {
    name: "Cards",
    path: "EVUser/GetCTags",
    queryParams: null,
    data: null,
    filters: [],
    sort: [],
    events: 0,
    is_loading: false,
    headers: [
      new DataHeader("N", "my_custom_id", DataPropType.Number, { isNotForEditing: true, isNotForClicking: true, isHidden: true }),
      new DataHeader("Идентификатор", "tagId", DataPropType.String, { isNotForEditing: true }),
      new DataHeader("Клиент", "cevuser.invCompanyName", DataPropType.String, { isNotForEditing: true, isHidden: true }),
      new DataHeader("Тип", "type", DataPropType.String, { isHidden: true }),
      new DataHeader("Име", "tagName", DataPropType.String, {}),
      new DataHeader("Цена", "customPrice", DataPropType.Money, { isNullable: true }),

      // new DataHeader("AutoCharge", "vidAutoCharge", DataPropType.BOOL, {}),
      new DataHeader("Блокиранa", "blocked", DataPropType.BOOL, {}),
    ],
    fixData: () => {
      for (var i = staticData.Cards.data.length - 1; i >= 0; i--) {
        if (staticData.Cards.data[i].type.toUpperCase().contains("VID")) {
          staticData.Cards.data.splice(i, 1);
        }
      }
    },
  },
};
export default Object.freeze(staticData);
